var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{ref:"validate",attrs:{"manual":true,"placement":_vm.placement,"content":_vm.validateMessage,"popper-class":"wind-validate-popover"},model:{value:(_vm.validateFlag),callback:function ($$v) {_vm.validateFlag=$$v},expression:"validateFlag"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }